import React, { useContext, useEffect, useState } from "react";
//import classes from "./pricingDropdowns.module.scss";
import classes from "../dashboardComponents/DashboardComponents.module.scss";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpIcon from '@mui/icons-material/Help';
import { OrgIdContext } from "../../store/orgId_context";
import { useTranslation } from "react-i18next";
import Button from "../UI/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle, Switch, LinearProgress } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import { useQuery } from "@tanstack/react-query";
import { DDD } from "../../lib/ddd/ddd";
import visa from '../../assets/visad.png';
import mastercard from '../../assets/mastercard.png';
import diners from '../../assets/dinersclubd.png';
import maestro from '../../assets/mestrod.png';
import visaelectron from '../../assets/visaelectrond.png';
import CurrencyTextField from '@lupus-ai/mui-currency-textfield'

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const RecurringCard = ({card}) => {
    const {aboutOrgId, sessionInfo, setSessionInfoHandler } = useContext(OrgIdContext);
    const [fungData, setFungData] = useState();
    const [value, setValue] = useState(0);
    const [details, setDetails] = useState();
    const {t} = useTranslation();

    useEffect(() => {
        if(!card || !card.Response) return;
        try{
            let data = JSON.parse(card.Response);
            setFungData(data);
            const ev = data?.events?.find((e) => {return e?.resourceType === "TX" && e?.status === "AUTHORIZED"});
            setDetails(ev);
        }catch{}
    }, [card]);

    const getFormattedAmount = (amount) => {
        if(!amount) return amount;
        try {
            return new Intl.NumberFormat('de-DE', { 
                style: 'currency', 
                currency: 'EUR' 
            }).format(amount);
        }catch(e){
            return amount;
        }
    }

    const storeCardData= (card) =>{
        if(!card) return card;

        try{
            if(!card.Response) return card;
            let data = JSON.parse(card.Response);
            const ev = data?.events?.find((e) => {return e?.resourceType === "TX" && e?.status === "AUTHORIZED"});
            card.ResponseJS = data;
            card.CardData = ev?.details?.card;
            console.log(card);
            return card;
        }catch(e){
            return card;
        }
    }

    const getCardImage = () => {
        switch(details?.details?.card?.brand?.toLowerCase()){
            case "visa":
                return <img src={visa} alt="visa" style={{maxHeight:"35px"}}/>;
            case "mastercard":
                return <img src={mastercard} alt="visa" style={{maxHeight:"35px"}}/>;
            case "diners":
                return <img src={diners} alt="visa" style={{maxHeight:"35px"}}/>;
            case "maestro":
                return <img src={maestro} alt="visa" style={{maxHeight:"35px"}}/>;
            default:
                return <div className="fw-bold fs-5">{details?.details?.card?.brand}</div>;
        }
    }

    return (<>
        <div className={`${classes["card-container"]}`} style={{backgroundColor:"inherit"}}>
            <Row >
                <Col className="col-2 align-content-center">
                    {getCardImage()}
                </Col>
                <Col className="fs-7">
                    {details && <>
                        <div className="d-flex">
                            <div>{details?.details?.card?.cardholderName}</div> <div className="ms-auto">&#9679;&#9679;&#9679;&#9679;{details?.details?.card?.lastFour}</div>
                        </div>
                        <div className="d-flex">
                            <div>{t("Expires")}: {details?.details?.card?.expiryMonth}/{details?.details?.card?.expiryYear}</div>
                            <div className="ms-auto text-decoration-underline fw-bold">{card?.Amount && <>{getFormattedAmount(card?.Amount/100)} {t("per Month")}</>}</div>
                        </div>
                    </>}
                </Col>
            </Row>
        </div>
        </>);
};

export default RecurringCard;
